export default __webpack_public_path__ + "static/media/love.ba79980c.svg";